import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "\n      sticky\n      inset-x-0\n      top-0\n      z-50\n      w-full\n      py-0\n      border-b border-base-200\n      bg-base-100 bg-opacity-75\n      backdrop-filter backdrop-blur-lg\n      blur-unsupported\n      transition\n      duration-200\n      ease-in-out\n    " }
const _hoisted_2 = { class: "mx-auto space-x-1 navbar max-w-screen-lg" }
const _hoisted_3 = { class: "flex items-center flex-none" }
const _hoisted_4 = {
  href: "/",
  class: "px-1 space-x-1 flex-0 btn btn-ghost",
  "aria-label": "Homepage"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "inline-block text-3xl font-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "uppercase" }, "STEAM"),
  /*#__PURE__*/_createElementVNode("span", { class: "lowercase text-base-content" }, "plug")
], -1)

import Logo from "@/components/Logo.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          _createVNode(Logo, { class: "w-11 text-base fill-current" }),
          _hoisted_5
        ])
      ])
    ])
  ]))
}
}

})